import { render } from "./FormSilogtran.vue?vue&type=template&id=1ee94791"
import script from "./FormSilogtran.vue?vue&type=script&lang=js"
export * from "./FormSilogtran.vue?vue&type=script&lang=js"

import "./FormSilogtran.vue?vue&type=style&index=0&id=1ee94791&lang=css"
script.render = render

export default script